var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUsageThisMonthIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.25,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#F5F5F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3650_34205)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 21.5347,
    y: 12.25,
    width: 5.56895,
    height: 24,
    fill: "#B0B3B3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28.4958,
    y: 24.9551,
    width: 5.56895,
    height: 11.2941,
    fill: "#B0B3B3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.5735,
    y: 20.7207,
    width: 5.56895,
    height: 15.5294,
    fill: "#B0B3B3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.6667,
    y: 24.25,
    width: 26.6667,
    height: 1.33333,
    fill: "#B0B3B3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.6667,
    y: 22.916,
    width: 26.6667,
    height: 1.33333,
    fill: "#F5F5F5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3650_34205"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(12 12.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsageThisMonthIcon);
export default __webpack_public_path__ + "static/media/UsageThisMonthIcon.57d8d75c74e43dc02169891edd38f677.svg";
export { ForwardRef as ReactComponent };